<script lang="ts">
/**
 * Bordered teal-tinted panel: small uppercase eyebrow + `.bd` body (trusted `{@html}`).
 */
interface Props {
  eyebrowHtml: string
  bodyHtml: string
  wrapStyle?: string
  eyebrowStyle?: string
  bodyClass?: string
  bodyStyle?: string
}

let {
  eyebrowHtml,
  bodyHtml,
  wrapStyle = 'padding:1rem 1.1rem;border:1px solid var(--gbr);border-radius:10px;background:rgba(17,160,165,.06);',
  eyebrowStyle = 'font-size:.62rem;letter-spacing:.12em;text-transform:uppercase;color:var(--g);margin-bottom:.45rem;',
  bodyClass = 'bd',
  bodyStyle = 'margin:0;font-size:.9rem;line-height:1.55;',
}: Props = $props()
</script>

<div style={wrapStyle}>
  <div style={eyebrowStyle}>{@html eyebrowHtml}</div>
  <p class={bodyClass} style={bodyStyle}>{@html bodyHtml}</p>
</div>
